export default __webpack_public_path__ + "static/media/goNaverShopping.a5527503.svg";